// API URL: always use current origin so it works in both preview and production
const API_URL = typeof window !== 'undefined' ? window.location.origin : '';
export default API_URL;
